import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { configureAuth } from '@vineyard/shared'
import App from './App'
import './globals.css'

configureAuth(import.meta.env.VITE_API_URL ?? '')

// Material Symbols FOUT 방지: 폰트 실제 다운로드 후 html.fonts-loaded 추가
// document.fonts.ready는 DOM에 해당 폰트 사용 요소가 없으면 즉시 resolve되어
// React 렌더링 전에 fonts-loaded가 추가되고 아이콘이 빈 박스로 보이는 문제가 있음
// document.fonts.load()로 명시적으로 폰트 다운로드를 트리거하고 기다림
document.fonts.load("24px 'Material Symbols Outlined'", 'search')
  .catch(() => null)
  .then(() => document.documentElement.classList.add('fonts-loaded'))
// 네트워크 오류/차단 대비 3초 폴백
setTimeout(() => document.documentElement.classList.add('fonts-loaded'), 3000)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
